export default `
mutation checkoutToteProducts($input:CheckoutToteProductsInput!) {
    CheckoutToteProducts(input: $input) {
      order {
        id
        successful
        operation_plans {
          label_text
          display_title
        }
      }
      payment {
        id
        state
        authorization_details
      }
    }
  }
`
